import { ConfigurationType } from 'data/types';
import { isHybridWholeHouseConfiguration } from 'utils/hybrid-whole-house-configuration';
import { WholeHouseDuctedConfigurationType } from 'utils/whole-house-ducted-configuration-types';

export function shouldLayOutDuctedZones(
  configuration: ConfigurationType
): boolean {
  const marked = configuration as WholeHouseDuctedConfigurationType;
  return (
    marked.layOutDuctedZones === true ||
    configuration.type === 'ducted' ||
    isHybridWholeHouseConfiguration(configuration)
  );
}
